import { initializeApp } from 'firebase/app';
import { firebaseConfig } from '@/config/firebase.config';

const app = initializeApp(firebaseConfig);

export default app;